'use strict';
var parent = require('../../actual/object/define-property');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/define-property.js
// module id = 632
// module chunks = 13